import React from "react";
import europeImg from "../../Images/Europe/susan-yin-62145-unsplash.jpg";
import asiaImg from "../../Images/Asia/rafa-prada-33648-unsplash.jpg";
import americaImg from "../../Images/America/erik-lindgren-23216-unsplash.jpg";
import { Link } from "react-router-dom";

export default function EmptyCart() {
  return (
    <div className="card-body">
      <h6 className="card-title text-center">
        It's seems that you have no items in cart
      </h6>
      <h6 className="card-subtitle small my-3 text-center">Check our offers here!</h6>
      <div className="row">
        <div className="col-12 row mb-3">
          <div className="col-6">
            <h5 className="card-title">Europe</h5>
            <img
              src={europeImg}
              class="card-img empty-cart-img-navbar "
              alt="Europe"
            />
          </div>
          <div className="col-6 pt-4 w-100">
            <p className="card-text navbar-cart-text m-0 text-justify">
              Discover castles, voyage through history, visit the oldest
              continent
            </p>
            <div className="w-100 text-right">
              <Link to="/europe" class="card-link">
                More info
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 row mb-3">
          <div className="col-6">
            <h5 class="card-title">Asia</h5>
            <img
              src={asiaImg}
              class="card-img empty-cart-img-navbar"
              alt="Asia"
            />
          </div>
          <div className="col-6 pt-4 w-100">
            <p className="card-text navbar-cart-text m-0 text-justify">
              Discover secrets in remote forests, celebrate variety of colors,
              sink in enduring traditions
            </p>
            <div className="w-100 text-right">
              <Link to="/asia" class="card-link">
                More info
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 row mb-3">
          <div className="col-6">
            <h5 class="card-title">America</h5>
            <img
              src={americaImg}
              class="card-img empty-cart-img-navbar"
              alt="America"
            />
          </div>
          <div className="col-6 pt-4 w-100">
            <p className="card-text navbar-cart-text m-0 text-justify">
              Discover ancient civilisations, learn about it's monumental
              history, feel the roar of great waterfalls
            </p>
            <div className="w-100 text-right">
              <Link to="/america" class="card-link">
                More info
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
